module.exports = __webpack_public_path__ + "img/da-img-5.a42f53e4.jpg";